import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const ThankYou = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const status = params.get('status') || 'success';

  return (
    <div className="thank-you-page">
      <Container className="py-5">
        <Card className="p-4 text-center shadow-sm">
          <div className="mb-3">
            {status === 'success' ? (
              <i className="bi bi-check-circle-fill text-success" style={{ fontSize: 48 }}></i>
            ) : (
              <i className="bi bi-x-circle-fill text-danger" style={{ fontSize: 48 }}></i>
            )}
          </div>
          <h3 className="mb-2">{status === 'success' ? 'Thank you for your purchase!' : 'Payment status'}</h3>
          <p className="text-muted mb-4">
            {status === 'success'
              ? 'Your transaction has been completed. A confirmation will be sent to your email.'
              : 'We could not verify your payment status. If you were charged, you will receive a confirmation.'}
          </p>
          <div className="d-flex justify-content-center gap-2">
            <Button as={Link} to="/products" variant="primary">Continue Shopping</Button>
            <Button as={Link} to="/" variant="outline-secondary">Go Home</Button>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default ThankYou;
